module.exports = __webpack_public_path__ + "img/f1.f8f0d199.png";